import { render } from "./AdvantagesSection.vue?vue&type=template&id=23215520&scoped=true&ts=true"
import script from "./AdvantagesSection.vue?vue&type=script&lang=ts"
export * from "./AdvantagesSection.vue?vue&type=script&lang=ts"

import "./AdvantagesSection.vue?vue&type=style&index=0&id=23215520&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23215520"]])

export default __exports__